import { useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { setTimezoneRequest, clearTimezone } from '../store/timezoneSlice';

const STABLE_ZIP_KEY = 'propertylocation_zip_zip';

function stripHashSuffix(key) {
  if (typeof key !== 'string') return key;
  return key.replace(/_[0-9a-f]{6,}$/i, '');
}

export function usePropertyZipTimezone() {
  const dispatch = useDispatch();
  const formCtx = useFormContext();
  const control = formCtx?.control;
  const getValues = formCtx?.getValues;

  const zipFieldName = useMemo(() => {
    if (!getValues) return STABLE_ZIP_KEY;
    const keys = Object.keys(getValues() || {});
    return (
      keys.find((k) => k === STABLE_ZIP_KEY) ||
      keys.find((k) => stripHashSuffix(k) === STABLE_ZIP_KEY) ||
      STABLE_ZIP_KEY
    );
  }, [getValues]);

  const zip = useWatch({ control, name: zipFieldName });

  useEffect(() => {
    const v = String(zip ?? '').trim();
    if (!v) {
      dispatch(clearTimezone());
      return;
    }
    const timer = setTimeout(() => {
      dispatch(setTimezoneRequest({ zip: v }));
    }, 300);
    return () => clearTimeout(timer);
  }, [zip, dispatch]);
}